<template>
  <div class="min-h-screen flex flex-col sm:justify-center items-center pt-6 sm:pt-0 bg-gray-100">
    <div class="max-w-6xl mx-auto py-10 sm:px-6 lg:px-8">
      <div class="shadow-lg bg-white rounded-lg rounded-b-none p-6">
        <div
          class="min-h-full flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
          <div
            class="max-w-md w-full space-y-8">
            <div>
              <img
                class="mx-auto h-12 w-auto"
                src="/img/andVet_logo.png">
              <p
                class="mt-6 text-center text-2xl font-extrabold text-gray-900">
                登録完了しました。
              </p>
              <p
                class="mt-6 text-center text-xl text-gray-900">
                模試の購入受付、模試開始(1/31)まで<br />しばらくお待ちください。<br />模試開始にあわせてメールでお知らせします。
              </p>
              <p
                class="mt-16 text-right text-lg text-red-500">
                確認用メールを登録いただいたメールアドレスに<br />送付いたしました。ご確認をお願いいたします。
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
